import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../../Widgets/LabeledTextArea";
import { ObservedBehaviorsFormValues } from "./interface";

interface EditFieldsProps {
  formValues: ObservedBehaviorsFormValues;
  handleChange: (
    field: keyof ObservedBehaviorsFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={6}>
      <LabeledTextArea
        multiline
        label="Direct Observations"
        value={formValues.directObservations}
        onChange={handleChange("directObservations")}
        helperText='Describe at least 3 direct observations you made during the assessment (i.e., not behaviors/skills/deficits the caregiver reported) and the physical location of the client during the observation (e.g., "Client was in the living room at his home during the observation"). Avoid saying "virtually" or "telehealth," instead here describe what you observed about the client.'
      />
      <LabeledTextArea
        multiline
        minRows={5}
        label="Strengths"
        value={formValues.strengths}
        onChange={handleChange("strengths")}
        helperText="What does this client do well? Include skills, talents, and positive behaviors we can build on during treatment."
      />
      <LabeledTextArea
        multiline
        minRows={5}
        label="Preferences"
        value={formValues.preferences}
        onChange={handleChange("preferences")}
        helperText="What activities, topics, or routines does this client enjoy?"
      />
    </Grid>
  );
};

export default EditFields;
